import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '@intranet/modules/login';
import { FinanceService } from './finance.service';

@Component({
    selector: 'finance',
    templateUrl: './finance.component.html',
    styleUrls: ['./finance.component.scss'],
})
export class FinanceComponent implements OnInit, OnDestroy {
    listing: string;
    showDialog = false;
    isFinance: boolean = false;
    isMonthEnd: boolean = false;

    constructor(
        private router: Router,
        private _loginService: LoginService,
        private financeService: FinanceService
    ) {}

    ngOnInit() {
        this.isFinance = this._loginService.checkAuth(['finance']);
        this.isMonthEnd = this._loginService.checkAuth(['Month-End']);
    }

    onStatus(status: string): void {
        // Gets status from tabs and sets the listing ID
        this.listing = status;
        this.router.navigateByUrl(`/finance/${status}`);
    }

    onClickToggle(toggle: boolean): void {
        // Tab button outputs EventEmitter which triggers modal
        this.showDialog = toggle;
    }

    ngOnDestroy() {
        this.financeService.resetFilterQuery();
    }
}
